import type { PageField } from './pageContract';

export function validatePageFilters(changes: Record<string, unknown>, schema: Record<string, PageField>) {
  if (!changes || typeof changes !== 'object' || Array.isArray(changes)) throw new Error('Filters must be an object.');
  for (const [key, value] of Object.entries(changes)) {
    const field = Object.prototype.hasOwnProperty.call(schema, key) ? schema[key] : undefined;
    if (!field) throw new Error(`Unsupported filter: ${key}`);
    if (field.type === 'enum' && !field.values?.includes(value as string))
      throw new Error(`Invalid ${key}: use one of its declared values.`);
    if (field.type === 'boolean' && typeof value !== 'boolean') throw new Error(`${key} must be true or false.`);
    if (
      field.type === 'date' &&
      (typeof value !== 'string' ||
        !/^\d{4}-\d{2}-\d{2}$/.test(value) ||
        Number.isNaN(Date.parse(value)) ||
        new Date(value).toISOString().slice(0, 10) !== value)
    )
      throw new Error(`${key} must be a valid YYYY-MM-DD date.`);
  }
}
